import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getData, patchData, postData } from "../../Service/ApiMethod";
import { LOGOUT, RECURITER_PROFILE, Subuser_Upload_Image, vaccancy_url } from "../../Service/service";
// import UploadFilePopup from "../home/component/UploadFilePopup";
import VaccancyBox from "./../Vaccancy/VaccancyBox";
import EditProfile from "./EditProfile";
import AWS from 'aws-sdk';
import { useTransition } from "react";
import Header from "../../common/HeaderAfterLogin";
import Footer from "../../common/Footer";
import Loader from "../login/Loader";
import OtpInput from "react-otp-input";
import NoVaccancy from "../../common/NoVaccancy";
// import { async } from "react-input-emoji";
import { lang } from "../../lang";
const MainProfile = () => { 
  const [editProfile, setEditProfile] = useState(false);
  const [ln,setLn] = useState('en')
  const [resData, setResData] = useState();
  // const [isLoggedin, setIsLoggedin] = useState(false);
  const [uploadPopup, setUploadPopup] = useState(false)
  // const [newImage, setNewImage] = useState()
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageURL, setImageURL] = useState()
  // const [image, setImage] = useState()
  // const [uploadedImage, setUploadedImage] = useState()
  // const [visible, setVisible] = useState(true)
  const [showPopup, setShowPopup] = useState(false)
  // const [showMore, setShowMore] = useState(false)
  const [loaderStart, setLoaderstart] = useState(false)
  const [sendOtp, setSendotp] = useState(false)
  const [otp,setOtp] = useState('')
  const navigate = useNavigate()

  const { t } = useTranslation()

  useEffect(()=>{
    if(localStorage.getItem("language") != null){
        setLn(localStorage.getItem("language"))
      } 
  },[])

  const removeElement = () => {
    const obj = {
      image: ''

    }
    postData(obj, Subuser_Upload_Image)
      .then((response) => response.json())
      .then((data) => {
        console.log("Data patch successful:", data);
        getDetail()

      })
      .catch((err) => {
        console.log("Data patch failed with error:", err);
      })
  }



  // const company = resData?.about_company

  // const handleEdit = () => {
  //   setShowPopup(!showPopup)

  // }

  const getDetail = () => {
    setLoaderstart(true)
    getData(RECURITER_PROFILE)
      .then((response) => response.json())
      .then((res) => {
        setLoaderstart(false)
        setResData(res.data);
        console.log('Main Profile Data', res.data) 
      })
      .catch((err) => {
        setLoaderstart(false)
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
      });
  };
  console.log('user Profile Data', resData)

  console.log(typeof resData);
  useEffect(() => {
    
    getDetail();
  }, [editProfile, uploadPopup]);

  useEffect(()=>{
    getVacancyData()
    setLoaderstart(true)
  },[])

  // const logout = () => {
  //   postData(resData,LOGOUT)
  //   localStorage.removeItem('catzapp_token');
  //   setIsLoggedin(false);
  // };

  // const handleClick = () => {
  //   console.log();
  //   let dataObj = {
  //     first_name: "Nitin",
  //     last_name: "Faujdar",
  //     email: "nitinfaujdar@gmail.com",
  //     image: "abcd.png",
  //     company: "1",
  //     short_bio: "Web",
  //     address: "Mathura",
  //     about_company: "Web Development Company",
  //   };
  //   patchData(dataObj, RECURITER_PROFILE)
  //     .then((response) => response.json())
  //     .then((data) => {
  //       console.log(data);
  //     })
  //     .catch((err) => {
  //       console.log("Error in categories from Post Form", err);
  //       console.log(" code Error", err);
  //     });
  // };
  // useEffect(() => {
  //   handleClick();
  // }, []);

  // ------------------------upload popup functions------------------

  const handleFileChange = (e) => {

    setSelectedFile(e.target.files[0])


    let s3 = new AWS.S3({
      accessKeyId: 'AKIA2GWTBVL6WX6U75ZC',
      secretAccessKey: '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',
      region: 'eu-central-1'
    });

    const params = {
      Bucket: 'catzapp-dev',
      Key: e.target.files[0]?.name,
      Body: e.target.files[0],
      ContentType: e.target.files[0]?.type || 'image/png',
      ACL: 'public-read'
    };

    s3.upload(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        console.log(`File uploaded successfully. ${data?.Location}`);
        setImageURL(data?.Location)
      }
    });

  }

  console.log('response', imageURL)

  console.log('image files', selectedFile)

  console.log('image url', imageURL)



  const handleUploadSubmit = (url) => {


    if (!selectedFile) {
      alert('Please select a file');
    }
    else {


      const obj = {
        image: `${url}                `

      }
      postData(obj, Subuser_Upload_Image)
        .then((response) => response.json())
        .then((data) => {
          console.log("Data patch successful:", data);
          setUploadPopup(false)
          getDetail()
        })
        .catch((err) => {
          console.log("Data patch failed with error:", err);
        })
    }
  }



  const handleCancelClick = () => {
    setUploadPopup(false)
  };


  const ref = useRef(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setUploadPopup && setUploadPopup(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }


  const popupStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "white",
    padding: "20px",
    zIndex: "1",
    border: "1px solid black",
    borderRadius: "10px"

  };




  const currentPg = useRef(1)
  const [searchKey, setSearchKey] = useState('')
  const [vaccancies, setvaccancies] = useState([])
  // ------------------------upload popup functions end-----------------
  const getVacancyData = () => {
    getData(vaccancy_url + "?pgNo=" + currentPg.current + "&keyword=" + searchKey)
      .then(res => res.json())
      .then(data => {
        console.log('vaccancies', data.data)
        setvaccancies(data.data.vacancy)
        // Totalpg.current = data.data.total_pages
        // setVacancies(data.data.vacancy?.filter((item) => (item?.title !== 'Default')))
        // setBackupVacancyData(data.data.vacancy?.filter((item) => (item?.title !== 'Default')))
      })
      .catch((err) => {
        console.log('err', err)
        // setIsErr(err)
      })
  }







  return (
    <>
    {
    loaderStart == true ? (<Loader/>):null
   }
      <Header />
      <div className="row">
        <div className="col-lg-9 col-sm-12 col-md-7">
          <div className="myProfile-details-area">
            <div className="users-info">
             
                <img
                  src="./images/pencilBlack.png"
                  className="rightPositionTopImg side-icon"
                  style={{ right: "26px", cursor: "pointer", zIndex: "99" }}
                  onClick={() => {
                    setEditProfile(true);
                  }}
                  alt=""
                />
             

              <div className="row rightPositionTopImg-inner d-flex">
                <div className=" left-position px-0 " style={{ height:'100px',display: 'flex', justifyContent: 'center', marginBottom: '15px',position:'relative' }}>
                  <div className="my-profile-userouter">
                  <img 
                    // src="./images/msg1.png" || "../images/users/avatar-2.jpg"
                    src={
                      // newImage? (newImage): 
                      (resData?.image) || "../images/Vector.png"
                    }
                    className="my-profile-user"
                    style={{}}


                    alt=""
                  />
                  </div>
                  {/* <p onClick={() => handleEdit()}>
                    <img src="../images/pencilBlack.png"
                      alt="imgg"
                      style={{ height: "15px" }}
                      className="addprofile "
                    />

                  </p> */}
                  {/* {
                    (resData?.user?.user_types == 'sub_user') &&
                    <div className="view-profile horizontal-center" style={{ cursor: 'pointer' }}>



                      <span className="view-profile-link" onClick={() => {
                        setUploadPopup(true)
                      }}>{t('Upload Image')}</span>
                    </div>
                  } */}

                  {showPopup &&

                    <div style={{ display: 'inline-block', position: 'absolute', right: '56px' }}>
                      <div className="bg-secondary" style={{ coor: 'black', border: '1px solid black', textAlign: 'center', borderRadius: '2px', width: 'fit-content' }} onClick={(e) => {
                        e.stopPropagation()
                        removeElement()

                        setShowPopup(!showPopup)
                      }}>{t('Delete')}l
                      </div>
                    </div>
                  }



                  {uploadPopup &&
                    //     <div className="blur-screen-full-area flex-center"  style={{position:'fixed', zIndex:'999999999999999999999'}}>
                    // <UploadFilePopup setUploadPopup={setUploadPopup} getUploadedImage={getUploadedImage}/>
                    // </div>

                    <>
                      <div>
                        <div className="popup" style={popupStyle} ref={ref}>
                          <h3>{t('Select File to Upload')}</h3>
                          <input type="file" onChange={(e) => {
                            handleFileChange(e)
                          }} className="custon-input w-100 mt-2" />
                          <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'center' }}>
                            <button className="btn btn-primary" style={{ marginRight: '10px' }} onClick={() => {
                              handleUploadSubmit(imageURL)
                            }}>{t('Upload')}</button>
                            <button className="btn btn-secondary" onClick={handleCancelClick} variant="danger">
                              {t('Cancel')}
                            </button>
                          </div>
                          {/* <img src={imageURL} alt='imageURL' /> */}
                        </div>

                      </div>
                    </>
                  }

                </div>
                {resData != undefined ? (
                  <div className="right-position pr-0">
                    <h3 className="user-name">
                      {resData?.first_name} {resData?.last_name}
                    </h3>
                    <a href="tel: +1 555 555 345" className="text">
                      {resData?.user_phone ? resData?.user_phone : resData?.user?.phone}
                    </a>{" "}
                    <br />
                    <a
                      href="mailto:brucebnr@gmail.com?subject = Feedback&body = Message"
                      className="text"
                    >
                      {resData?.email}
                    </a>
                    <p className="text"> {resData?.user.user_types == "recruiter" || resData?.user.user_types == "jobseeker" ? "Admin":"Sub-User"}</p>
                    <p className="myProfile-heading mt-3 mb-2">
                      {resData?.company_name || ""}
                    </p>
                    <p className="text mb-2">
                      {" "}
                      <img
                        src="./images/earth.png"
                        alt=""
                        className="mr-2 side-icon-small "
                      />{" "}
                      {resData?.company_website}
                    </p>
                    <p className="text">
                      <img
                        src="./images/location-black.png"
                        alt=""
                        className="mr-2 side-icon-smallocate"
                      />{" "}
                      {resData?.company_location}
                    </p>
                  </div>
                ) : null}
              </div>
              
            </div>
          </div>
    
                <div style={{display:'flex',justifyContent:'space-between'}}>
          <h5 className="my-2 form-heading recent-vacancy">{lang && Object.keys(lang).length > 0 ? lang[ln]?.tab["Recent jobs"]:""}</h5>
          <button className="link theme-btn btn-block w-75 setButtonwidth" onClick={()=>navigate('/vaccancy')} style={{}}>{lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["View All Vacancy"]:""}</button>
          </div>
 {/* <VaccancyBox col="col-lg-12 col-md-12 col-sm-12"  /> */}


 {vaccancies.map((item, index) => {
              // const salary = Number(item?.compensation_amount);

              // if (salary > 1000) {
              //   Package = Math.floor(salary / 1000) + "k";
              //   PackageTo = Math.floor((salary + 5000) / 1000) + "k";
              // } else {
              //   Package = salary;
              //   PackageTo = salary + 1000;
              // }

              // if (item.compensation_details === "Monthly") {
              //   // item.compensation_details = "M";
              // } else if (item.compensation_details === "Yearly") {
              //   // item.compensation_details = "Y";
              // } else if (item.compensation_details === "Day") {
              //   item.compensation_details = "Daily";
              // } else if (item.compensation_details === "Weekly") {
              //   // item.compensation_details = "W";
              // }
              if (item?.length === 0) {
                return <NoVaccancy />;
              } else {
                return (
                  <div  key={index} style={{
                    // border:'1px solid black',
                    flex: '1 1 21rem',
                    flexWrap: 'wrap',
                    alignSelf: 'normal',
                    display: 'flex'
                  }}
                    // onClick={(e) => {
                    //   setVaccancyId(e.target.id);
                    //   console.log(vacancyId);
                    //   moveVacancyId(item);
                    // }}
                  >
                    <div
                      className="recommended-profile p-2"
                      id={item?.id}
                      name="clcikedd"
                      style={{
                        // border:'1px solid blue',
                        alignSelf: 'normal',
                        flexWrap: 'wrap',
                        display: 'flex'
                      }}
                    >
                      <div
                        className="row"
                        style={{
                          // border:'1px solid blue',
                          alignSelf: 'normal',
                          display: 'flex',
                          flexWrap: 'wrap'
                        }}
                      >
                        <div className="col-md-3 col-12 px-0 relative flex-center vaccancy-pic-area"
                          // onClick={(e) => {
                          //   setVaccancyId(e.target.id);
                          //   console.log(vacancyId);
                          //   moveVacancyId(item);
                          // }}
                          style={{
                            borderRadius: '3px',
                         
                          }}
                        >
                               <div className="category-profile" style={{}}>
                          <img
                            src={item?.job_category_icon || "./images/plumber.png"}
                            alt=""
                            className="profile-img"
                          />
                          </div>
                          <div className="profile-match horizontal-center px-2"

                          >
                            <img
                              src="./images/blue-eye.png"
                              className="mr-1"
                              alt=""
                            />
                            <span className="match-score" style={{ color: 'blue' }}>
                              {item?.no_of_applicants} {item?.no_of_applicants > 1 ? `${t('Applications')}` : `${t('Application')}`}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-9 col-12 pr-0 mt-1"
                          style={{
                            // border:'1px solid purple',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between'
                          }}>
                          <h2 className="card-heding relative"
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              // border:'1px solid purple'
                            }}
                          >
                            {item?.title}
                            {/* <img
                              src="./images/pencilBlack.png"
                              alt=""
                              style={{ }}
                              className="addprofile side-icon"
                              key={index}
                              id={item?.id}
                              // onClick={(e) => {
                              //   e.stopPropagation()
                              //   setShowPopup(!showPopup)
                              //   setIindex(index)
                              //   setUserId(item?.id)
                              // }}
                            /> */}
                            {/* {((iindex == index) && showPopup) &&

                              <div className="imgg-style" style={{}}>


                                <div className="" style={{ width: 'fit-content', cursor: 'pointer', marginBottom: '3px', border: '1px solid black', textAlign: 'center', borderRadius: '2px', backgroundColor: '#e9eff6', fontSize: '16px', padding: '4px' }}
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    handleEdit(item)

                                  }}>{t('Edit')} </div>


                                <div className="" style={{ border: '1px solid black', textAlign: 'center', borderRadius: '2px', cursor: 'pointer', backgroundColor: '#e9eff6', fontSize: '16px', padding: '4px' }} onClick={(e) => {
                                  e.stopPropagation()
                                  setDeletePopup(true)
                                  console.log(item,"djjjf",userId);
                                  localStorage.setItem("vaccancy_id", userId)

                                }}>{t('Delete')}</div>
                              </div>
                            } */}

                            {/* <img
                          src="./images/err.jpg"
                          alt=""
                          style={{ height: "16px" }}
                          className="addprofile"
                          id={item.id}
                          onClick={(e) =>{ setDeletePopup(true); localStorage.setItem("vaccancy_id", e.target.id)}}
                        /> */}
                          </h2>
                          <p className="designation mt-2" >
                            {item?.urgent_vacancy ? (
                              <span>{t('Required')} {item?.job_category_name} {t('Immediately')}</span>
                            ) : (
                              <span>{lang && Object.keys(lang).length > 0 ? lang[ln]?.new["No Required Immediately"]:""} </span>
                            )}
                          </p>
                          <div className="row mt-1"
                            style={{
                              display: 'flex',
                              alignContent: 'space-between',
                              // border:'1px solid blue',
                              height: 'unset'
                            }}>
                            {/* <div className="col-6 px-0">
                          <p className="card-subHeading">Total Experience</p>
                          <p className="card-subHeading">Work Location</p>
                          <p className="card-subHeading">Package</p>
                        </div>
                        <div className="col-6 px-0">
                          <p className="profile-info">
                            {item?.experience} {(item?.experience)>1 ? 'Years': 'Year'}
                          </p>
                          <p className="profile-info">{(item?.work_location)}</p>
                          <p className="profile-info">
                            {" "}
                            {item?.currency} {item?.compensation_amount} {item?.compensation_details}
                          </p>
                        </div> */}
                            {/* ------------------------new columns------------------------- */}
                            <div className="col-12 px-0">
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                // border:'1px solid black'
                              }} >
                                <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Total Experience']:""}</p>
                                <p className="profile-info">
                                  {item?.experience} {(item?.experience) > 1 ? `${lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Years']:''}` : `${lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Year']:""}`}
                                </p>
                              </div>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                // border:'1px solid black'
                              }} >
                                <p className="card-subHeading worklocation">{t('Work Location')}</p>
                                <p className="profile-info">
                                  {/* {(item?.work_location)} */}
                                  {(item?.work_location?.length > 15) ? item?.work_location.slice(0, 15) + '...' : item?.work_location}
                                </p>
                              </div>
                              <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                // border:'1px solid black'
                              }} >
                                <p className="card-subHeading">{lang && Object.keys(lang).length > 0 ? lang[ln]?.RecommendedComp['Package']:""}</p>
                                <p className="profile-info">
                                  {item?.currency} {item?.compensation_amount} {lang && Object.keys(lang).length > 0 ? lang[ln]?.new[item?.compensation_details]:""}
                                </p>
                              </div>
                            </div>
                            {/* ------------------------new columns end------------------------- */}

                            {/* <div className="col-6 px-0">
                          <p className="horizontal-center">
                            <img
                      src="./images/match-badge.png"
                      className="img-size18"
                      alt=""
                    />
                    <span className="ms-1 match-profile">99% Match</span>
                          </p>
                        </div> */}

                            <div style={{
                              width: '100%', padding: '0', textAlign: 'right',
                              // border:'1px solid red'
                            }}>
                              <p className="post-day text-right"
                                style={{
                                  width: '100%',
                                  // border:'1px solid green',
                                  textAlign: 'end',
                                  paddingBottom: '0'
                                }} >
                                {lang && Object.keys(lang).length > 0 ? lang[ln]?.myVacancy['Posted']:""} {new Date(item?.posted_on).toDateString()} {t('ago')}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <hr style={{background:'black', height:'1px', fontSize:'5px', fontWeight:'bold'}} /> */}
                  </div>
                );
              }
            })
       
        
        }
          
        </div>

        <div className="col-lg-3 col-sm-12 col-md-5 px-0">
          <div className="relative">
            <div className="my-profile my-profile main-profile">
              {/* <div className="loginFirst">
            <div className="flex-center flex-column">
                <h2 className="heading">Welcome To Catch-Up</h2>
                <Link to="/" className="mt-4 link theme-btn btn-block w-75">Login</Link>
                <Link to="/" className="link mt-4">
                    <p className="text">Create An Account</p>
                </Link>
            </div>
        </div> */}
              <div className="">

                {!(resData?.user?.user_types == 'sub_user') &&
                  <>
                    <div className="profiles-box">
                      <Link to="/subcription" className="text text-link text-decoration-none">
                        <div className="row horizontal-center">
                          <div className="col-2 px-0">
                            <div
                              className="p-2 bg-theme flex-center"
                              style={{ borderRadius: "10px" }}
                            >
                              <img className="side-icon" src="./images/subcription-bag.png" alt="" />
                            </div>
                          </div>
                          <div className="col">

                            {lang && Object.keys(lang).length > 0 ? lang[ln]?.Newtranslation['My Subcription']:""}

                          </div>
                          <div className="col-1 px-0 justify-content-end d-flex h-100">
                            <img src="./images/go-arrow.png" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>
                    <hr className="line" />
                  </>
                }

                <div className="profiles-box">
                  <Link to="/mylists" className="text text-link text-decoration-none">
                    <div className="row horizontal-center">
                      <div className="col-2 px-0">
                        <div
                          className="p-2 bg-theme flex-center"
                          style={{ borderRadius: "10px" }}
                        >
                          <img className="side-icon" src="./images/list.png" alt="" />
                        </div>
                      </div>
                      <div className="col">
                        {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['My Lists']:""}
                      </div>
                      <div className="col-1 px-0 justify-content-end d-flex h-100">
                        <img src="./images/go-arrow.png" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <hr className="line" />
                <div className="profiles-box">
                  <Link to="/vaccancy" className="text text-link text-decoration-none">

                    <div className="row horizontal-center">
                      <div className="col-2 px-0">
                        <div
                          className="p-2 bg-theme flex-center"
                          style={{ borderRadius: "10px" }}
                        >
                          <img className="side-icon" src="./images/vaccancy-black.png" alt="" />
                        </div>
                      </div>
                      <div className="col">
                        {lang && Object.keys(lang).length > 0 ? lang[ln]?.tab['My Vacancies']:""}
                      </div>
                      <div className="col-1 px-0 justify-content-end d-flex h-100">
                        <img src="./images/go-arrow.png" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <hr className="line" />

                <div className="profiles-box">
                  <Link to="/unlock-profiles" className="text text-link text-decoration-none">

                    <div className="row horizontal-center">
                      <div className="col-2 px-0">
                        <div
                          className="p-2 bg-theme flex-center"
                          style={{ borderRadius: "10px" }}
                        >
                          <img src="./images/unlock-profile.png" alt="" className="for-unloacked"/>
                        </div>
                      </div>
                      <div className="col">
                        {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['My Unlocked Candidates']:""}
                      </div>
                      <div className="col-1 px-0 justify-content-end d-flex h-100">
                        <img src="./images/go-arrow.png" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <hr className="line" />






                {!(resData?.user?.user_types == 'sub_user') &&
                  <>
                    <div className="profiles-box">
                      <Link to="/subusers" className="text text-link text-decoration-none">

                        <div className="row horizontal-center">
                          <div className="col-2 px-0">
                            <div
                              className="p-2 bg-theme flex-center"
                              style={{ borderRadius: "10px" }}
                            >
                              <img className="side-icon" src="./images/sub-users.png" alt="" />
                            </div>
                          </div>
                          <div className="col">
                            {t('Sub Users')}
                          </div>
                          <div className="col-1 px-0 justify-content-end d-flex h-100">
                            <img src="./images/go-arrow.png" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>
                    <hr className="line" />
                  </>
                }



                <div className="profiles-box">
                  <Link to="/recomended-msgs" className="text text-link text-decoration-none">
                    <div className="row horizontal-center">
                      <div className="col-2 px-0">
                        <div
                          className="p-2 bg-theme flex-center"
                          style={{ borderRadius: "10px" }}
                        >
                          <img src="./images/MSG.png" alt=""
                            style={{ height: '20px', width: '20px' }}
                          />
                        </div>
                      </div>
                      <div className="col">
                        {t('Stored Messages')}
                      </div>
                      <div className="col-1 px-0 justify-content-end d-flex h-100">
                        <img src="./images/go-arrow.png" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>

                <hr className="line" />

                {!(resData?.login_type === "social_login") &&
                  <>
                    <div className="profiles-box">
                      <Link to="/jobseeker-settings" className="text text-link text-decoration-none">

                        <div className="row horizontal-center">
                          <div className="col-2 px-0">
                            <div
                              className="p-2 bg-theme flex-center"
                              style={{ borderRadius: "10px" }}
                            >
                              <img className="side-icon" src="./images/settings.png" alt="" />
                            </div>
                          </div>
                          <div className="col">
                            {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['Settings']:""}
                          </div>
                          <div className="col-1 px-0 justify-content-end d-flex h-100">
                            <img src="./images/go-arrow.png" alt="" />
                          </div>
                        </div>
                      </Link>
                    </div>
                    <hr className="line" />
                  </>
                }


                {/* 
              <div className="profiles-box">
                <div className="row horizontal-center">
                  <div className="col-2 px-0">
                    <div
                      className="p-2 bg-theme flex-center"
                      style={{ borderRadius: "10px" }}
                    >
                      <img src="./images/bell-black.png" alt="" />
                    </div>
                  </div>
                  <div className="col">
                    <p className="text">Alerts/Notifications</p>
                  </div>
                  <div className="col-1 px-0 justify-content-end d-flex h-100">
                    <img src="./images/go-arrow.png" alt="" />
                  </div>
                </div>
              </div>
              <hr className="line" /> */}

                <div className="profiles-box">
                  <Link to="/privacy_policies" className="text text-link text-decoration-none">

                    <div className="row horizontal-center">
                      <div className="col-2 px-0">
                        <div
                          className="p-2 bg-theme flex-center"
                          style={{ borderRadius: "10px" }}
                        >
                          <img className="side-icon" src="./images/guard.png" alt="" />
                        </div>
                      </div>
                      <div className="col">
                        {t('Privacy & Policies')}
                      </div>
                      <div className="col-1 px-0 justify-content-end d-flex h-100">
                        <img src="./images/go-arrow.png" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <hr className="line" />

                <div className="profiles-box">
                  <Link to="/contact-support" className="text text-link text-decoration-none">

                    <div className="row horizontal-center">
                      <div className="col-2 px-0">
                        <div
                          className="p-2 bg-theme flex-center"
                          style={{ borderRadius: "10px" }}
                        >
                          <img className="side-icon" src="./images/contact.png" alt="" />
                        </div>
                      </div>
                      <div className="col">
                        {t('Contact Support')}
                      </div>
                      <div className="col-1 px-0 justify-content-end d-flex h-100">
                        <img src="./images/go-arrow.png" alt="" />
                      </div>
                    </div>
                  </Link>
                </div>
                <hr className="line" />
                <div className="profiles-box">
                  <div
                    className="flex-center flex-column"
                    // onClickCapture={logout}
                    onClick={(e) => {
                      // e.stopPropagation()
                      localStorage.clear()
                      window.location.href = 'https://catzapp.com/';
                    }}
                  >
                    <p  className="link theme-btn btn-block w-75">
                      {lang && Object.keys(lang).length > 0 ? lang[ln]?.MyProfile['Log Out']:""}
                    </p>
                  </div>
                  <>
                  {
                    resData?.user?.user_types == "recruiter" || resData?.user?.user_types == "jobseeker" ? 
                    (<div
                      className="flex-center flex-column"
                      style={{marginTop: 10,cursor:'pointer'}}
                      // onClickCapture={logout}
                      onClick={async(e) => { 
                      let bodydata = {
                        phone: resData?.user_phone ? resData?.user_phone : resData?.user?.phone,
                        "user_types": "recruiter",
                      };
                      const response = await fetch("https://api.catzapp.com/send/otp/", {
                        method: 'POST',
                        headers: {
                          Accept: 'application/json',
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(bodydata),
                      });
                      var responseJson = await response.json();
                  
                      console.log('signUpSaga Response ====>', responseJson);
                      if(responseJson.status_code == 200){
                      // navigation.navigate('InterOtp', { phone: myProfle?.user?.phone,keyType:"delete" })
                      
                      setSendotp(true)
                      }
                        
                      }}
                    >
                      {/* <Link to="/login" className="link theme-btn btn-block w-75"> */}
                        {lang && Object.keys(lang).length > 0 ? lang[ln]?.myVacancy['Delete']:""}
                      {/* </Link> */}
                    </div>):null}
                  </>
                </div>
              </div>
            </div>
            {sendOtp ? (
<>
<div className="modalNew">
  <div className="submodalNew">
          <div style={{textAlign:'center'}}>  <img src="./images/otp.png" alt="" className="login-img" />
          <p className="text text-center">
            We have sent you a OTP to  {resData?.user_phone ? resData?.user_phone : resData?.user?.phone}
          </p> </div>
          <OtpInput  inputStyle={{width:'87%', fontSize:'15px'}}
          onChange={(e)=> setOtp(e)}
          className="mobile_four_digit_verification_code flex-center justify-content-between my-3 "
              // name="ssn-3"
          value={otp}
          isInputNum ="number"
          id="OTP"
          numInputs={6}
          separator={<span></span>}
          
        />
        <button className="theme-btn mt-1" type="submit" onClick={async()=>{
          if(otp != ""){
            let bodydata = {
              "deletion_otp": otp
            };
            console.log(bodydata,"otp")
            const response = await fetch("https://api.catzapp.com/recruiter/delete_recruiter/", {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
              },
              body: JSON.stringify(bodydata),
            });
            var responseJson = await response.json();
            
            console.log('signUpSaga Response ====>', responseJson);
            if(responseJson.status_code == 200){
            // navigation.navigate('InterOtp', { phone: myProfle?.user?.phone,keyType:"delete" })
            setSendotp(false)
            alert("Delete Successfully")
            navigate("/login");
            }else{
              alert("something is wrong")
            }
          }
 
  
        }}>Submit</button>
        <p style={{cursor:"pointer"}} onClick={()=>setSendotp(false)}>Cancel</p>
        </div>
        </div>
</>):null}
            {/* <div className="my-profile mt-2">
        <div className="profiles-box">
          <div className="row">
            <div className="col-2 px-0">
              <img src="./images/user.png" alt="" />
            </div>
            <div className="col">
              <p className="text">My Subcriptions</p>
            </div>
            <div className="col-1 px-0 justify-content-end d-flex">
              <img src="./images/go-arrow.png" alt="" />
            </div>
          </div>
        </div>
        <hr className="line" />
      </div> */}
          </div>
        </div>
        {editProfile ? (
          <EditProfile
            submit={setEditProfile}
            userData={resData}
            getProileData={getDetail}
          />
        ) : null}
        {/* {resData != undefined ? resData.first_name : null} */}
      </div>
      <Footer />
    </>
  );
};

export default MainProfile;
